"use client";

import { useLocale } from "next-intl";
import { usePathname, useRouter } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { useTransition } from "react";

const LOCALES = [
	{ value: "en", label: "EN" },
	{ value: "ro", label: "RO" },
] as const;

export default function LanguageSwitcher() {
	const locale = useLocale();
	const router = useRouter();
	const pathname = usePathname();
	const tCommon = useTranslations("Common");
	const [isPending, startTransition] = useTransition();

	const setLocale = (nextLocale: string) => {
		startTransition(() => {
			router.replace(pathname, { locale: nextLocale });
		});
	};

	return (
		<div
			className="inline-flex items-stretch rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50/80 dark:bg-gray-800/80 overflow-hidden"
			role="group"
			aria-label={tCommon("language")}
		>
			{LOCALES.map(({ value, label }) => {
				const isActive = locale === value;
				return (
					<button
						key={value}
						type="button"
						onClick={() => setLocale(value)}
						disabled={isPending}
						className={`
							min-w-[3.6rem] py-2 px-3 text-[1.5rem] font-bold transition-colors duration-200
							focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1
							disabled:opacity-60 disabled:cursor-not-allowed
							${
								isActive
									? "bg-primary text-white dark:bg-primary dark:text-white"
									: "text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 hover:text-primary dark:hover:text-primary"
							}
							${value === "en" ? "border-r border-gray-200 dark:border-gray-600" : ""}
						`}
						aria-pressed={isActive}
						aria-current={isActive ? "true" : undefined}
					>
						{label}
					</button>
				);
			})}
		</div>
	);
}
